import {useMutation, UseMutationOptions, useQueryClient} from '@tanstack/react-query'
import {httpEditView, HttpEditViewOptions} from '../http/views.http'
import {View} from '../types'
import {QUERY_KEYS} from '@/queryClient'

export const useEditView = (options?: Omit<UseMutationOptions<View, unknown, HttpEditViewOptions>, 'mutationFn'>) => {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: data => httpEditView(data),
        ...options,
        onSuccess: (data, variables, context) => {
            options?.onSuccess?.(data, variables, context)
            queryClient.invalidateQueries({queryKey: [QUERY_KEYS.VIEWS]})
            queryClient.invalidateQueries({queryKey: [QUERY_KEYS.VIEW, variables.urlParams.id]})
        }
    })
}
